import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useMileageOptionsRateLogic from "./useMileageOptionRateLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "id", label: "Id", allowSorting: true, decimalCount: 0 },
  {
    field: "mileage_option",
    label: "Mileage option",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
  {
    field: "season",
    label: "Season",
    allowSorting: true,
    subvalue: "Name",
    showInFilter: true,
  },
  {
    field: "currency",
    label: "Currency",
    allowSorting: true,
    subvalue: "code",
    showInFilter: true,
  },
  {
    field: "class",
    label: "Category",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
  { field: "daily_rate", label: "Daily rate", allowSorting: true },
  { field: "weekly_rate", label: "Weekly rate", allowSorting: true },
  { field: "monthly_rate", label: "Monthly rate", allowSorting: true },
];

const MileageOptionRatePage = () => {
  const { apiRoute, addRoles, deleteRoles, editRoles, initFields } =
    useMileageOptionsRateLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];

      //API endpoint to fetch the data
      // Call the function for each API endpoint
      const promises = [
        fetchDataAndMapToField(
          config,
          "mileageoptions",
          "mileage_option",
          temp
        ),
        fetchDataAndMapToField(config, "seasons", "season", temp, "Name"),
        fetchDataAndMapToField(
          config,
          "currencies",
          "currency",
          temp,
          "code",
          "symbol"
        ),
        fetchDataAndMapToField(config, "vehicleclasses", "class", temp, "name"),
      ];

      // Wait for all promises to resolve
      await Promise.all(promises);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Mileage Options Rates" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"mileage_option_rate"}
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        hasImport={true}
        importConfig={{
          relationshipMappings: [
            { field: "mileage_option", lookupTable: "mileage_option", lookupField: "name" },
            { field: "season", lookupTable: "season", lookupField: "Name" },
            { field: "currency", lookupTable: "currency", lookupField: "code" },
            { field: "class", lookupTable: "vehicle_class", lookupField: "name" }
          ]
        }}
        enhancedTable={true}
      />
    </div>
  );
};

export default MileageOptionRatePage;
